import { Component, OnInit } from '@angular/core';
import { HttpService } from '../services/http/http.service';
@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})

export class WelcomeComponent implements OnInit{
  constructor(private readonly api: HttpService) {}

  menuItems:any;
  contentTitle:string='';
  contentId:number=0;


  ngOnInit(): void {
    // caricamento dinamico menu a sinistra

      this.api.getMenuHomePage().subscribe({
        next: (response:any) => {
         this.menuItems = response.result;
         this.contentTitle = this.menuItems[0].descrizione;
         this.contentId = this.menuItems[0].id;

      }
      })
  }

  // valorizzazione contenuto dinamico in pagina in base al click sul menu a sinistra
  loadContent(event:any) {
    this.contentTitle = event.descrizione;
    this.contentId = event.id
  }

  // funzione di login
  login() {
    window.location.href='secured/landing'
  }
}

